import Loading from '@/shared/components/Carregando';
import Select from 'react-select';
import TabelaMovimentos from '@/modules/home/tabelamovimentos';
import { DataIso } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { GetNucleos } from '@/modules/structure/nucleo/nucleo.service';
import { ReadDefensoriaDto, ReadDefensorResponseDto, ReadNucleoDto } from '@/api.types';
import { useEffect, useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSearchParams } from 'react-router-dom';
import { LuArrowLeftRight, LuFilter, LuPrinter, LuScale, LuScrollText, LuSearch, LuUsers } from 'react-icons/lu';

interface IOpcao { value: number; label: string; }

export default function HomeIndexMPage() {
  const tabelaMovimentosRef = useRef<{ buscarRegistros: () => void }>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const [loaded, setLoaded] = useState(false);

  const [listaDefensorias, setListaDefensorias] = useState<ReadDefensoriaDto[]>([]);
  const [listaNucleos, setListaNucleos] = useState<ReadNucleoDto[]>([]);

  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [nucleos, setNucleos] = useState<IOpcao[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);

  const [referenciaI, setReferenciaI] = useState(
    searchParams.get('referenciaI') || DataIso(new Date(), 'yyyy-MM'),
  );
  const [referenciaF, setReferenciaF] = useState(
    searchParams.get('referenciaF') || DataIso(new Date(), 'yyyy-MM'),
  );
  const [defensoriaId, setDefensoriaId] = useState(
    Number(searchParams.get('defensoriaId')) || 0,
  );
  const [nucleoId, setNucleoId] = useState(
    Number(searchParams.get('nucleoId')) || 0,
  );
  const [defensorId, setDefensorId] = useState(
    Number(searchParams.get('defensorId')) || 0,
  );

  useEffect(() => {
    Promise.all([
      GetDefensorias(0, 1000),
      GetNucleos(0, 1000),
      EnumerateDefensores(0, 1000),
    ])
      .then((res) => {
        res[0].objects.unshift({ id: -1, nome: '(todas)' } as ReadDefensoriaDto);
        setDefensorias(
          res[0].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setListaDefensorias(res[0].objects);

        res[1].objects.unshift({ id: -1, nome: '(todos)' } as ReadNucleoDto);
        setNucleos(
          res[1].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setListaNucleos(res[1].objects);

        res[2].objects.unshift({ id: -1, nome: '(todos)' } as unknown as ReadDefensorResponseDto);
        setDefensores(
          res[2].objects.map((item) => {
            const nome = item.pessoa?.nome || '-';
            return { value: item.id, label: nome };
          }),
        );

        setLoaded(true);
      })
      .catch((res) => {
        console.error(res);
      });
  }, []);

  const handleBuscarRegistros = () => {
    if (tabelaMovimentosRef.current) {
      tabelaMovimentosRef.current.buscarRegistros();
    }
  };

  const atualizarFiltrosNaURL = () => {
    setSearchParams({
      referenciaI,
      referenciaF,
      defensoriaId: String(defensoriaId),
      nucleoId: String(nucleoId),
      defensorId: String(defensorId),
    });
  };

  useEffect(() => {
    atualizarFiltrosNaURL();
  }, [referenciaI, referenciaF, defensorId, nucleoId, defensoriaId]);

  const corDestaque = '#d6ac41'; // mesma cor do .bg-yellow
  const corDestaqueDark = '#6b4f12';
  const fundoDestaque = '#fbf5e6';

  return (
    <>
      <div className="container py-4">
        <section className="text-center mb-4">
          <div className="d-flex justify-content-center mb-2">
          </div>
          <div className="text-uppercase text-muted small fw-semibold">
            Corregedoria Geral
          </div>
          <h2 className="mt-1 mb-1" style={{ color: '#2f2a1f', fontWeight: 700 }}>
            Relatório de Atendimento dos Defensores
          </h2>
          <div className="text-muted" style={{ maxWidth: 860, margin: '0 auto' }}>
            Acompanhe e gere relatórios detalhados sobre os atendimentos realizados pelos defensores públicos.
          </div>
        </section>

        {loaded ? (
          <>
            {(() => {
              const cardStyle: React.CSSProperties = {
                borderRadius: 14,
                border: '1px solid rgba(0,0,0,0.06)',
                boxShadow: '0 10px 25px rgba(16, 24, 40, 0.06)',
              };

              const cardHeaderStyle: React.CSSProperties = {
                background: '#f6f4ee',
                borderBottom: '1px solid rgba(0,0,0,0.06)',
                borderTopLeftRadius: 14,
                borderTopRightRadius: 14,
              };

              const headerIconStyle: React.CSSProperties = {
                width: 28,
                height: 28,
                borderRadius: 8,
                background: fundoDestaque,
                color: corDestaqueDark,
                border: '1px solid rgba(214,172,65,0.30)',
              };

              const selectStyles = {
                control: (base: any) => ({
                  ...base,
                  minHeight: 38,
                  height: 38,
                  borderRadius: 10,
                  borderColor: 'rgba(0,0,0,0.12)',
                  boxShadow: 'none',
                }),
                valueContainer: (base: any) => ({
                  ...base,
                  paddingLeft: 40,
                  paddingTop: 0,
                  paddingBottom: 0,
                }),
                input: (base: any) => ({
                  ...base,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (base: any) => ({
                  ...base,
                  height: 38,
                }),
                placeholder: (base: any) => ({
                  ...base,
                  color: '#9aa0a6',
                }),
                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
              };

              const SelectComIcone = ({
                id,
                icon,
                ...props
              }: {
                id: string;
                icon: JSX.Element;
                [key: string]: any;
              }) => {
                return (
                  <div className="position-relative">
                    <span
                      className="position-absolute top-50 translate-middle-y"
                      style={{
                        left: 12,
                        color: '#8a8f98',
                        pointerEvents: 'none',
                        zIndex: 2,
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                      aria-hidden
                    >
                      {icon}
                    </span>
                    <Select
                      inputId={id}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={selectStyles}
                      {...props}
                    />
                  </div>
                );
              };

              return (
                <>
                  <div className="card mb-3" style={cardStyle}>
                    <div className="card-header d-flex align-items-center gap-2 fw-semibold" style={cardHeaderStyle}>
                      <span className="d-inline-flex align-items-center justify-content-center" style={headerIconStyle} aria-hidden>
                        <LuFilter size={16} strokeWidth={2} />
                      </span>
                      Filtros de Pesquisa
                    </div>
                    <div className="card-body">
                      <div className="row g-3 align-items-end">
                        <div className="col-12 col-md-6 col-lg-4">
                          <label htmlFor="periodos-referencia" className="form-label mb-1">
                            Período de Referência
                          </label>
                          <div className="row g-2" id="periodos-referencia">
                            <div className="col-6">
                              <input
                                id="referenciaI"
                                name="referenciaI"
                                title="Dessa data..."
                                type="month"
                                className="form-control"
                                value={referenciaI}
                                onChange={(e) => {
                                  setReferenciaI(DataIso(e.target.value, 'yyyy-MM'));
                                }}
                                required
                              />
                            </div>
                            <div className="col-6">
                              <input
                                id="referenciaF"
                                name="referenciaF"
                                title="...até essa data."
                                type="month"
                                className="form-control"
                                value={referenciaF}
                                onChange={(e) => {
                                  setReferenciaF(DataIso(e.target.value, 'yyyy-MM'));
                                }}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                          <label htmlFor="defensor" className="form-label mb-1">
                            Defensor(a)
                          </label>
                          <SelectComIcone
                            id="defensor"
                            icon={<LuUsers size={16} strokeWidth={1.8} />}
                            options={defensores}
                            defaultValue={defensores.find((a) => a.value === defensorId)}
                            placeholder="Selecione um defensor(a)"
                            onChange={(e: any) => {
                              const sel = defensores.find((a) => a.value === e!.value);
                              const f: ReadDefensorResponseDto = {
                                id: sel!.value,
                                nome: sel!.label,
                              } as unknown as ReadDefensorResponseDto;
                              if (f?.id) setDefensorId(f.id);
                            }}
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                          <label htmlFor="defensoria" className="form-label mb-1">
                            Defensoria
                          </label>
                          <SelectComIcone
                            id="defensoria"
                            icon={<LuScale size={16} strokeWidth={1.8} />}
                            options={defensorias}
                            defaultValue={defensorias.find((a) => a.value === defensoriaId)}
                            placeholder="Selecione uma defensoria"
                            onChange={(e: any) => {
                              const sel = defensorias.find((a) => a.value === e!.value);
                              const f: ReadDefensoriaDto = {
                                id: sel!.value,
                                nome: sel!.label,
                              } as ReadDefensoriaDto;
                              if (f?.id) setDefensoriaId(f.id);
                            }}
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                          <label htmlFor="nucleo" className="form-label mb-1">
                            Núcleo
                          </label>
                          <SelectComIcone
                            id="nucleo"
                            icon={<LuArrowLeftRight size={16} strokeWidth={1.8} />}
                            options={nucleos}
                            defaultValue={nucleos.find((a) => a.value === nucleoId)}
                            placeholder="Selecione um núcleo"
                            onChange={(e: any) => {
                              const sel = nucleos.find((a) => a.value === e!.value);
                              const f: ReadNucleoDto = {
                                id: sel!.value,
                                nome: sel!.label,
                              } as ReadNucleoDto;
                              if (f?.id) setNucleoId(f.id);
                            }}
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-auto ms-lg-auto d-flex justify-content-lg-end">
                          <button
                            type="button"
                            className="btn btn-sm fw-semibold"
                            style={{
                              background: corDestaque,
                              borderColor: corDestaque,
                              color: '#fff',
                              borderRadius: 10,
                              padding: '0.45rem 0.75rem',
                              fontSize: '0.875rem',
                            }}
                            onClick={handleBuscarRegistros}
                          >
                            <span className="d-inline-flex align-items-center gap-2">
                              <LuSearch size={18} strokeWidth={2} aria-hidden />
                              Filtrar
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div ref={contentRef} className="card" style={cardStyle}>
                    <div className="card-header d-flex align-items-center justify-content-between" style={cardHeaderStyle}>
                      <div className="d-flex align-items-center gap-2 fw-semibold">
                        <span className="d-inline-flex align-items-center justify-content-center" style={headerIconStyle} aria-hidden>
                          <LuScrollText size={16} strokeWidth={2} />
                        </span>
                        Tabela de Relatórios Pendentes e Enviados
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-light fw-semibold"
                        style={{
                          borderRadius: 10,
                          border: '1px solid rgba(0,0,0,0.10)',
                        }}
                        title="Imprimir Tabela"
                        onClick={() => {
                          reactToPrintFn();
                        }}
                      >
                        <span className="d-inline-flex align-items-center gap-2">
                          <LuPrinter size={16} strokeWidth={2} aria-hidden />
                          Imprimir
                        </span>
                      </button>
                    </div>
                    <div className="card-body">
                      <TabelaMovimentos
                        ref={tabelaMovimentosRef}
                        referenciaI={referenciaI}
                        referenciaF={referenciaF}
                        defensoria={defensoriaId}
                        nucleo={nucleoId}
                        defensor={defensorId}
                        defensorias={listaDefensorias}
                        nucleos={listaNucleos}
                      />
                    </div>
                    <div className="card-footer text-muted text-center">
                      Defensoria Pública do Estado de Sergipe
                    </div>
                  </div>
                </>
              );
            })()}
          </>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
}
